//@flow

import React from "react";
import { Field } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";

import { Dropdown } from "modules/ChangeServiceForm/components/shared/CommonComponents";

const Title = ({ fieldName }: { fieldName: string }) => {
  const options = [
    { text: "Doktor", value: "Doktor" },
    { text: "Prof.", value: "Professor" },
  ];

  return (
    <>
      <Field name={fieldName}>
        {({ input: { onChange, value }, meta }: FieldRenderProps) => {
          return <Dropdown fullWidth placeholder="Titel" options={options} onChange={onChange} value={value} />;
        }}
      </Field>
    </>
  );
};

export default Title;
